export enum OperationSTSEnum {
    STS_UNKNOWN = 'STS_UNKNOWN',
    STS_01 = 'STS_01',
    STS_02 = 'STS_02',
    STS_ES_01 = 'STS_ES_01',
    STS_ES_02 = 'STS_ES_02',
    REG_AUTHORIZATION = 'REG_AUTHORIZATION',
    LUC = 'LUC'
}